// @ts-check

/** @typedef {import("@evolved/domain").SystemField} SystemField */

/** @type {SystemField} */
export const name = {
  entityType: "PRODUCT",
  type: "TEXT",
  title: "Name",
  canEdit: true,
  isSystem: true,
  dataIndex: "name",
  isRequired: true,
  canMatchEntityBy: true,
};

export const COLLECTION = Object.freeze([name]);
